import { Link } from 'react-router-dom';
import PageShell from '../../../components/layout/PageShell';
import { useAuth } from '../../../context/AuthContext';
import { getUserRoles } from '../../../utils/userRoles';
import { TASK_CATALOG, computeGuidance } from '../../../utils/guidanceTasks';

function GuidancePage() {
  const { token, user } = useAuth();
  const userRoles = Array.from(getUserRoles(user));

  const guidanceContext = {
    ...(user?.guidanceContext || user?.tournamentContext || {}),
    isRegistered: Boolean(token || user?.id),
  };

  const guidance = computeGuidance(userRoles, guidanceContext);

  return (
    <PageShell containerClassName="p-0">
      <section className="d-flex flex-column gap-3">
        <div>
          <span className="badge bg-primary-subtle text-primary-emphasis mb-2">Guidance</span>
          <h1 className="h3 mb-2">Guidance Checklist</h1>
          <p className="text-muted mb-0">This is a step-by-step guide to reach Match Started.</p>
        </div>

        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
              <strong>{guidance.completedCount}/{guidance.totalRelevantCount} completed</strong>
              <span className="text-muted small">{guidance.progressPercent}% complete</span>
            </div>
            <div className="progress" role="progressbar" aria-valuenow={guidance.progressPercent} aria-valuemin={0} aria-valuemax={100}>
              <div className="progress-bar" style={{ width: `${guidance.progressPercent}%` }} />
            </div>
          </div>
        </div>

        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <h2 className="h5 mb-3">Checklist</h2>
            <ul className="list-group list-group-flush">
              {guidance.relevantTasksOrdered.map((taskId, index) => {
                const task = TASK_CATALOG[taskId];
                const done = guidance.completedTasks.includes(taskId);
                const isNext = !done && guidance.nextTask === taskId;

                return (
                  <li key={taskId} className={`list-group-item px-0 py-3 ${isNext ? 'bg-primary-subtle' : ''}`}>
                    <div className="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                      <div>
                        <p className="mb-1 fw-semibold">
                          {index + 1}. {task.label} {done ? '✓' : ''}
                        </p>
                        <p className="text-muted mb-0 small">{task.description}</p>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {isNext ? <span className="badge text-bg-primary">Next task</span> : null}
                        {!done ? (
                          <Link className="btn btn-sm btn-outline-primary" to={task.route}>
                            Open
                          </Link>
                        ) : null}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <h2 className="h5 mb-3">Next 3 actions</h2>
            {guidance.next3Actions.length ? (
              <div className="d-flex gap-2 flex-wrap">
                {guidance.next3Actions.map((task) => (
                  <Link key={task.id} className="btn btn-outline-primary" to={task.route}>
                    {task.label}
                  </Link>
                ))}
              </div>
            ) : (
              <p className="mb-0 text-success">All relevant tasks are complete. You are ready for Match Started.</p>
            )}
          </div>
        </div>
      </section>
    </PageShell>
  );
}

export default GuidancePage;
